module.exports = __webpack_public_path__ + "static/media/bg-full.71c832dd.jpg";